import { transformDTODate } from "@skylab-shared/core";
import { DocumentPaymentDTO } from "@skylab-shared/dataModel";
import { Transform, Type } from "class-transformer";
import { OrderPaymentType } from "../common/order-payment-kind";
import { OrderSourceKind } from "../common/order-source.kind";
import { OrderStatus } from "../common/order-status";
import { OrderCustomerDTO } from "./order-customer.dto";
import { OrderDeliveryDTO } from "./order-delivery.dto";
import { OrderDocumentDTO } from "./order-document.dto";
import { OrderItemDTO } from "./order-item.dto";
import { OrderPaymentSummaryDTO } from "./order-payment-summary.dto";
import { OrderPaymentDTO } from "./order-payment.dto";
import { OrderRecipientDTO } from "./order-recipient.dto";
import { OrderSaleDocumentDTO } from "./order-sale-document.dto";

export class OrderPostDTO {
	public orderId: string;
	@Type(() => OrderItemDTO) public items: OrderItemDTO[];
	@Type(() => OrderRecipientDTO) public recipient: OrderRecipientDTO | null;
	@Type(() => OrderDeliveryDTO) public delivery: OrderDeliveryDTO | null;
	@Type(() => OrderDocumentDTO) public document: OrderDocumentDTO | null;
	public currencyExternalId: string;
	public source: OrderSourceKind;
	public paymentType: OrderPaymentType;
	public externalNumber: string;
	public number: string;
	public statusId: number;
	public sourceProviderId: string;
	@Transform(transformDTODate, { toClassOnly: true }) public createDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public orderDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public dueDate: Date | null;
	public notesPublic: string;
	public notesPrivate: string;
	public commission: number;
	@Type(() => DocumentPaymentDTO) public payments: OrderPaymentDTO[];
}

class OrderGetItemDTO {
	public orderId: string;
	public number: string;
	public marketplaceUrl: string;
	public storeOrderId: string;
	public source: OrderSourceKind;
	public externalNumber: string;
	public statusId: number;
	public statusCode: OrderStatus;
	@Type(() => OrderCustomerDTO) public customer: OrderCustomerDTO;
	public createdDate: Date;
	public orderDate: Date;
	public dueDate: Date;
	@Type(() => OrderRecipientDTO) public recipient: OrderRecipientDTO;
	public currencyExternalId: string;
	public totalNetValue: number;
	public totalGrossValue: number;
	@Type(() => OrderDeliveryDTO) public delivery: OrderDeliveryDTO;
	public shipments: null;
	@Type(() => OrderDocumentDTO) public document?: OrderDocumentDTO | null;
	@Type(() => OrderSaleDocumentDTO) public saleDocument?: OrderSaleDocumentDTO | null;
	@Type(() => OrderItemDTO) public items: OrderItemDTO[];
	@Type(() => OrderPaymentSummaryDTO) public paymentSummary: OrderPaymentSummaryDTO;
	public totalCommission: number;
	public notesPublic: string;
	public notesPrivate: string;
}

export class OrderGetDataDTO {
	@Type(() => OrderGetItemDTO) public item: OrderGetItemDTO;
}

export class OrderGetDTO {
	@Type(() => OrderGetDataDTO) public data: OrderGetDataDTO;
}
